var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReadNotif(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Completed",
    transform: "translate(-682 -852)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19320",
    "data-name": "Rectangle 19320",
    width: 24,
    height: 24,
    transform: "translate(682 852)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(686.993 857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M9.363,2.176A5.707,5.707,0,0,0,3.126,3.468h0a5.243,5.243,0,0,0,4.9,8.667h0a5.721,5.721,0,0,0,4.233-4.568.715.715,0,1,1,1.4.28,7.147,7.147,0,0,1-5.356,5.689A6.673,6.673,0,0,1,2.067,2.507m0,0A7.135,7.135,0,0,1,9.894.848a.715.715,0,1,1-.531,1.328",
    fill: "#1d1d1b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M13.45,2.417a.715.715,0,0,1,.04,1.01l-5.72,6.2a.715.715,0,0,1-1.031.021L4.356,7.261A.715.715,0,0,1,5.367,6.25L7.224,8.107l5.215-5.649A.715.715,0,0,1,13.45,2.417Z",
    fill: "#1d1d1b",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadNotif);
export default __webpack_public_path__ + "static/media/read-notif.b245cb1ccc6fe0cee54857e2f9b1abab.svg";
export { ForwardRef as ReactComponent };